import { Box, Tooltip, IconButton } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useTranslation } from "react-i18next";

// Plan strategy options shown across MP Settings, Run MP > Plan Policy and Create New Version.
const STRATEGIES = ["forward", "forward2", "backward"];
// forward / forward2 는 포워드의 "계획 기준" 선택지이므로 "포워드 (계획 기준)" 문구로 안내한다.
const BASIS_KEY = { forward: "planningBasisEarliestAvailable", forward2: "planningBasisDueDatePullIn" };
const DESC_KEY = {
  forward: "planStrategyDescForward",
  forward2: "planStrategyDescForward2",
  backward: "planStrategyDescBackward"
};

const PlanStrategyHelp = ({ iconSx, placement = "right" }) => {
  const { t } = useTranslation();

  const tooltipContent = (
    <Box sx={{ py: 0.5 }}>
      {STRATEGIES.map((strategy) => (
        <Box key={strategy} sx={{ mb: 0.75, "&:last-of-type": { mb: 0 } }}>
          <Box component="span" sx={{ fontWeight: "bold" }}>{BASIS_KEY[strategy] ? `${t("forward")} (${t(BASIS_KEY[strategy])})` : t(strategy)}</Box>
          {` : ${t(DESC_KEY[strategy])}`}        </Box>
      ))}
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} arrow placement={placement}>
      <IconButton size="small" aria-label={t("planStrategy")} sx={{ p: 0.25, color: "primary.main", ...iconSx }}>
        <HelpOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default PlanStrategyHelp;
